const isAuthenticate = () => {
  return localStorage.getItem("userToken") || undefined;
};

export default isAuthenticate;
